import { render, staticRenderFns } from "./docfolder.vue?vue&type=template&id=2485ab74&scoped=true&"
import script from "./docfolder.vue?vue&type=script&lang=js&"
export * from "./docfolder.vue?vue&type=script&lang=js&"
import style0 from "./docfolder.vue?vue&type=style&index=0&id=2485ab74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2485ab74",
  null
  
)

export default component.exports